import React, { useState } from "react";
import { ProviderContext, withSnackbar } from "notistack";
import FirebaseService from "../../services/firebase/FirebaseService";
import StandardModal from "./StandardModal";
import ModalSize from "./ModalSize";
import LoadingButton from "../Loading/LoadingButton";
import { FormControl, FormLabel, TextField } from "@material-ui/core";
import { GENERAL_MAX_LENGTH } from "../../utils/stringFormatting";
import "../Modals/EditStudentModal.scss";
import ReadleeProfile from "../../services/firebase/ReadleeProfile";

interface EditStudentProps {
  student: ReadleeProfile;
  open: boolean;
  cancelClose: () => void;
}

const EditStudentModal = (props: EditStudentProps & ProviderContext) => {
  const [loadingButtonState, setLoadingButtonState] = useState(LoadingButton.BeforeLoading);
  const [firstName, setFirstName] = useState(props.student.firstName);
  const [lastName, setLastName] = useState(props.student.lastName);
  const [email, setEmail] = useState(props.student.email);

  const updateFirstName = (event: React.ChangeEvent<{ value: string }>) => setFirstName(event.target.value);
  const updateLastName = (event: React.ChangeEvent<{ value: string }>) => setLastName(event.target.value);
  const updateEmail = (event: React.ChangeEvent<{ value: string }>) => setEmail(event.target.value);

  const save = async () => {
    const emailRegex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailRegex.test(email)) {
      props.enqueueSnackbar("Email format is invalid", {
        variant: "error",
        autoHideDuration: 5000,
      });
    } else if (firstName.length === 0) {
      props.enqueueSnackbar("Cannot save empty first name.", {
        variant: "error",
        autoHideDuration: 5000,
      });
    } else if (lastName.length === 0) {
      props.enqueueSnackbar("Cannot save empty last name.", {
        variant: "error",
        autoHideDuration: 5000,
      });
    } else {
      try {
        await Promise.all([
          FirebaseService.updateReadleeProfile(props.student.uid, "firstName", firstName),
          FirebaseService.updateReadleeProfile(props.student.uid, "lastName", lastName),
          FirebaseService.updateReadleeProfile(props.student.uid, "email", email),
        ]);
        props.cancelClose();
        props.enqueueSnackbar("Student information updated.", {
          variant: "success",
          autoHideDuration: 5000,
        });
      } catch {
        props.enqueueSnackbar("Could not update student info.", {
          variant: "error",
          autoHideDuration: 5000,
        });
      }
    }
    setLoadingButtonState(LoadingButton.BeforeLoading);
  };

  return (
    <StandardModal
      cancelClose={props.cancelClose}
      onSubmit={save}
      changeLoadingButtonState={setLoadingButtonState}
      loadingButtonState={loadingButtonState}
      title={<div className="title">Edit Class Information</div>}
      open={props.open}
      size={ModalSize.large}
      onlyOneButton={false}
      submitButtonText="Save"
    >
      <div className="edit-student-modal">
        <FormControl variant="outlined" style={{ width: "100%" }}>
          <FormLabel className="label">First Name</FormLabel>
          <TextField
            value={firstName}
            variant="outlined"
            id="first"
            onChange={updateFirstName}
            inputProps={{ maxLength: GENERAL_MAX_LENGTH }}
            fullWidth
            className="text-field"
          />
          <FormLabel className="label">Last Name</FormLabel>
          <TextField
            value={lastName}
            variant="outlined"
            id="last"
            onChange={updateLastName}
            inputProps={{ maxLength: GENERAL_MAX_LENGTH }}
            fullWidth
            className="text-field"
          />
          <FormLabel className="label">Email Name</FormLabel>
          <TextField
            value={email}
            variant="outlined"
            id="email"
            onChange={updateEmail}
            inputProps={{ maxLength: GENERAL_MAX_LENGTH }}
            fullWidth
          />
        </FormControl>
      </div>
    </StandardModal>
  );
};

export default withSnackbar(EditStudentModal);
